import React from 'react'
import { cn, getLeaseMetaValues, getMetaLabelValues } from '~/lib'
import type { Listing } from '~/models'

export default function ListingMeta({
  className,
  listing,
}: {
  className?: string
  listing: Listing
}) {
  const meta = listing.meta as { [key: string]: any }
  const county = listing.property.county?.trim() || ''

  const renderLeaseMeta = () => {
    const values = getLeaseMetaValues(listing)
    if (values.length === 0) {
      return null
    }
    return (
      <>
        {values.map(({ label, value }, index) => {
          return (
            <React.Fragment key={index}>
              <dt className="col-span-5 py-0.5 text-muted-foreground">
                {label}
              </dt>
              <dd className="col-span-7 py-0.5 text-right font-semibold">
                {value}
              </dd>
            </React.Fragment>
          )
        })}
      </>
    )
  }

  return (
    <dl className={cn(className, 'grid grid-cols-12 text-base')}>
      <>
        {renderLeaseMeta()}
        {getMetaLabelValues(meta).map(({ key, label, value }) => {
          return (
            <React.Fragment key={key}>
              <dt className="col-span-5 py-0.5 text-muted-foreground">
                {label}
              </dt>
              <dd className="col-span-7 py-0.5 text-right font-semibold">
                {value}
              </dd>
            </React.Fragment>
          )
        })}

        {county && (
          <>
            <dt className="col-span-5 py-0.5 text-muted-foreground">
              {county.includes('Parish') ? 'Parish' : 'County'}
            </dt>
            <dd className="col-span-7 py-0.5 text-right font-semibold">
              {county.replace('County', '').replace('Parish', '').trim()}
            </dd>
          </>
        )}
      </>

      <dt className="col-span-5 py-0.5 text-muted-foreground">Created</dt>
      <dd className="col-span-7 py-0.5 text-right font-semibold">
        {listing.created.toDateString()}
      </dd>
      <dt className="col-span-5 py-0.5 text-muted-foreground">Updated</dt>
      <dd className="col-span-7 py-0.5 text-right font-semibold">
        {listing.modified.toDateString()}
      </dd>
    </dl>
  )
}
